<template>
	<div>
		<div v-if="!stripeLoaded" class="text-center mb-4">
			<div class="spinner-border text-primary text-center" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
		<StripeElements
			v-if="stripeLoaded"
			v-slot="{ elements }"
			ref="elms"
			:stripe-key="stripeKey"
			:instance-options="instanceOptions"
			:elements-options="elementsOptions"
		>
			<StripeElement
				ref="card"
				:elements="elements"
				:options="cardOptions"
				@change="
					($event) => {
						$event.complete ? generateToken() : $emit('acceptToken', null)
					}
				"
			/>
		</StripeElements>
	</div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { defineComponent, ref, onBeforeMount } from 'vue'
import { StripeElements, StripeElement } from 'vue-stripe-js'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
	components: {
		StripeElements,
		StripeElement,
	},
	emits: ['acceptToken'],
	setup(props, context) {
		
		const stripeKey = ref(usePage().props.value.app.stripe.key)

		const token = ref()

		const card = ref()

		const elms = ref()

		const instanceOptions = ref({})

		const elementsOptions = ref({})

		const cardOptions = ref({
			hidePostalCode: true,
			iconStyle: 'solid',
		})
		const stripeLoaded = ref(false)

		const generateToken = async () => {
			const cardElement = card.value.stripeElement
			elms.value.instance.createToken(cardElement).then((result) => {
				if (result.token) {
					token.value = result.token.id
					context.emit('acceptToken', token.value)
				}
			})
		}

		onBeforeMount(() => {
			const stripePromise = loadStripe(stripeKey.value)
			stripePromise.then(() => {
				stripeLoaded.value = true
			})
		})

		return {
			stripeKey,
			stripeLoaded,
			instanceOptions,
			elementsOptions,
			cardOptions,
			generateToken,
			card,
			elms,
			token,
		}
	},
}
</script>
